import { arrayOf, bool } from 'prop-types';
import React from 'react';
import { Col, Input, Label, Row } from 'reactstrap';

import CategoryContext from '../../generic/CategorySelect/CategoryContext';
import SubmittableForm from '../../generic/SubmittableForm';
import withProducts from '../../products/withProducts/with-products';
import { productShape } from '../../prop-types';
import OnsiteAverageDailyRate from '../../quote-editor/OnsiteAverageDailyRate.container';
import ProductSelection from '../../quote-editor/ProductSelection.container';
import QuoteLineBundleSelection from '../../quote-editor/QuoteEditor/QuoteLineBundleSelection.container';
import QuoteLinesBulkEditor from '../../quote-editor/QuoteEditor/QuoteLinesBulkEditor.container';
import QuoteLineSelectionToggle from '../../quote-editor/QuoteEditor/QuoteLineSelectionToggle.container';
import QuoteForm from '../../quote-editor/QuoteForm.container';
import ConnectedQuoteLineFilters from '../../quote-editor/QuoteLineFilters';
import QuoteLineTable from '../../quote-editor/QuoteLineTable.container';
import HELP_TEXTS from '../../quote-editor/utils/help-texts';

class ProjectQuoteEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
    };
  }

  render() {
    const { isEditing, products } = this.props;
    const { showDetails } = this.state;
    return (
      <SubmittableForm className="c-quote-editor wide-container-fluid">
        <div className="mb-4">
          <QuoteForm isEditing={isEditing} />
        </div>

        <Row className="justify-content-between">
          {isEditing && (
            <Col sm={6} className="d-flex">
              <div className="flex-grow-1 mr-2">
                <ProductSelection />
              </div>
              <div className="flex-grow-1">
                <QuoteLineBundleSelection />
              </div>
            </Col>
          )}
          <Col sm="auto">
            <OnsiteAverageDailyRate
              boxView
              helpText={HELP_TEXTS.onsiteAverage.dailyRate}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col sm={12}>
            <CategoryContext.Consumer>
              {categories => (
                <ConnectedQuoteLineFilters
                  allCategories={categories}
                  allProducts={products}
                />
              )}
            </CategoryContext.Consumer>
          </Col>
        </Row>

        <Row className="my-3 justify-content-between">
          <Col sm="auto">{isEditing && <QuoteLineSelectionToggle />}</Col>
          <Label sm="auto" className="d-flex">
            <Input
              type="checkbox"
              checked={showDetails}
              onChange={event =>
                this.setState({ showDetails: event.target.checked })
              } // eslint-disable-line react/jsx-curly-newline
              disabled={!isEditing}
            />
            Show product configuration inline
          </Label>
          <Col sm="auto">
            <QuoteLinesBulkEditor />
          </Col>
        </Row>

        <QuoteLineTable showDetails={showDetails} isEditing={isEditing} />
      </SubmittableForm>
    );
  }
}

ProjectQuoteEditor.propTypes = {
  isEditing: bool.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
};

export default withProducts({})(ProjectQuoteEditor);
